<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <theHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheTemplateI
          :heading="investedStandardDetail[0]?.name"
          :indicated-item="[]"
        >
          <template #contents>
            <div class="p-the-page-i03">
              <div class="p-the-page-i03__inner">
                <IInvestedStandardList
                  :invested-standard-detail="investedStandardDetail"
                />
              </div>
            </div>
          </template>
        </TheTemplateI>
      </div>
    </div>
    <FloatingGivePointButton />
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { getGrantCriteriaDetails } from "@/general/store/api";
import grantCriteriadetails from "@/general/store/modules/grantCriteriaDetails";

import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import IInvestedStandardList from "@/general/components/pages/parts/GrantCriteriaDetails/IInvestedStandardList.vue";
import TheTemplateI from "@/general/components/templates/TheTemplateI.vue";
import store from "@/general/store";
import { GrantCriteria } from "gen/ricapi/api";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";
import { getQueryString } from "@/common/assets/js/utils/queryParams";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheHeader,
    TheBreadcrumb,
    TheFooter,
    IInvestedStandardList,
    TheTemplateI
  },
  store: store
})
export default class GrantCriteriaDetails extends Vue {
  grantCriteriaDetailsModel?: GrantCriteria;
  investedStandardDetail: any = [];
  breadcrumb: any = [];

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    await this.setInvestedStandardDetail();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // const id = parseInt(urlParams.get("id") as string);
    const searchParam = urlParams.get("search") ? urlParams.get("search") : "";
    const orderingParam = urlParams.get("ordering")
      ? (urlParams.get("ordering") as string)
      : "";
    const pageParm = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;

    const redirect_from = urlParams.get("redirect_from")
      ? (urlParams.get("redirect_from") as string)
      : "";

    if (redirect_from != undefined && redirect_from == "my-page") {
      this.breadcrumb.push(
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: "マイページ",
          url: CONST_DATA.SITE_MAP.MY_PAGE,
          pageType: "lower"
        },
        {
          text: "付与基準一覧",
          url:
            `${CONST_DATA.SITE_MAP.GRANT_CRITERIA}?ordering=` +
            orderingParam +
            "&search=" +
            searchParam +
            "&page=" +
            pageParm,
          pageType: "lower"
        },
        {
          text: "付与基準詳細",
          url: "",
          pageType: "lower"
        }
      );
    } else if (
      redirect_from != undefined &&
      redirect_from == "point-confirmation"
    ) {
      this.breadcrumb.push(
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: "ポイント確認",
          url: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,
          pageType: "lower"
        },
        {
          text: "付与基準一覧",
          url:
            `${CONST_DATA.SITE_MAP.GRANT_CRITERIA}?ordering=` +
            orderingParam +
            "&search=" +
            searchParam +
            "&page=" +
            pageParm,
          pageType: "lower"
        },
        {
          text: "付与基準詳細",
          url: "",
          pageType: "lower"
        }
      );
    } else {
      this.breadcrumb = [
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: "付与基準一覧",
          url:
            `${CONST_DATA.SITE_MAP.GRANT_CRITERIA}?ordering=` +
            orderingParam +
            "&search=" +
            searchParam +
            "&page=" +
            pageParm,
          pageType: "lower"
        },
        {
          text: "付与基準詳細",
          url: "",
          pageType: "lower"
        }
      ];
    }

    const id = parseInt(urlParams.get("id") as string);
    const response = await getGrantCriteriaDetails(id, "", "");

    // データが取得できなかった場合（404/400等）は一覧画面へ遷移する
    if (!response || (response as any).isError) {
      window.location.href = CONST_DATA.SITE_MAP.GRANT_CRITERIA;
      return;
    }

    this.investedStandardDetail = [response];
    await commons.getBreadcrumb(this.breadcrumb);
  }
  setInvestedStandardDetail() {
    this.investedStandardDetail =
      grantCriteriadetails.grantCriteriaDetailsModel || [];
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-i03 {
  @include pc {
    padding: 0 0 rem(16);
  }
  @include sp {
  }

  &__inner {
  }
}
</style>
